import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { formatLeadTime } from '../../utils/format-lead-time';

/**
 * Subtle inline notice that informs the user about the configured booking
 * lead-time window for a category. Renders nothing when no lead time is set.
 * Shared by the start-slot-picker and the court-grid-view.
 */
@Component({
  selector: 'app-lead-time-notice',
  standalone: true,
  imports: [],
  template: `
    @if (leadTimeMinutes != null) {
      <p class="lead-time-notice" role="note">
        Buchungen sind max. {{ formatted }} im Voraus möglich.
      </p>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .lead-time-notice {
        margin: 0 0 0.5rem;
        color: #6b7280;
        font-size: 0.8125rem;
        line-height: 1.35;
      }
    `,
  ],
})
export class LeadTimeNoticeComponent {
  @Input() leadTimeMinutes: number | null = null;

  get formatted(): string {
    return this.leadTimeMinutes == null ? '' : formatLeadTime(this.leadTimeMinutes);
  }
}
